module.exports = __webpack_public_path__ + "img/zhenjiang_s.7bd36d6.png";